import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDatePretty } from '../../../utils/helpers/time';
import { RootState } from '../../../utils/redux_store/store';
import { INavBarState, NavBarProps } from '../interfaces';

export const useNavBarState = ({ variant = 'default' }: NavBarProps): INavBarState => {
  const isJobPosting = variant === 'job_posting';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAppsOpen, setIsAppsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  // Close mobile menu on desktop resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Universal Shortcut to toggle Apps Launchpad (Ctrl+K, Cmd+K, Ctrl+Space, Alt+A)
  useEffect(() => {
    if (isJobPosting) return;

    const handleGlobalKeyDown = (e: KeyboardEvent) => {
      const isCmdOrCtrl = e.metaKey || e.ctrlKey;
      if (
        (isCmdOrCtrl && (e.key === 'k' || e.key === 'K')) ||
        (isCmdOrCtrl && (e.key === ' ' || e.code === 'Space')) ||
        (e.altKey && (e.key === 'a' || e.key === 'A'))
      ) {
        e.preventDefault();
        setIsAppsOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleGlobalKeyDown);
    return () => window.removeEventListener('keydown', handleGlobalKeyDown);
  }, [isJobPosting]);

  const companyLogo = useSelector((state: RootState) => state.logo.companyLogo);
  const formattedDate = formatDatePretty(new Date());
  const userName = localStorage.getItem('firstname') || '';

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenDropdown(null);
  };

  return {
    isJobPosting,
    isMobileMenuOpen,
    isAppsOpen,
    openDropdown,
    formattedDate,
    userName,
    companyLogo,
    toggleMobileMenu,
    closeMobileMenu,
    setIsAppsOpen,
    setOpenDropdown,
  };
};
